export default __webpack_public_path__ + "img/battery.2592d61d.png";